/* unplugin-vue-components disabled */import script from "./customButton.vue?vue&type=script&setup=true&lang=js"
export * from "./customButton.vue?vue&type=script&setup=true&lang=js"

import "./customButton.vue?vue&type=style&index=0&id=7d1c432e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d1c432e"]])

export default __exports__